var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -27,
    y: -27,
    width: 94,
    height: 94
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(13.5px)",
      clipPath: "url(#bgblur_0_5445_229089_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 27,
    width: 40,
    height: 40,
    rx: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.0002L26.0002 14",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 26.0002L14 14",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229089_clip_path",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesClose);
export default __webpack_public_path__ + "static/media/stories-close.d773c7215ee3967b91a3300bc044960e.svg";
export { ForwardRef as ReactComponent };